import axios from "axios";
import Cookies from 'js-cookie';
import 
{ 
  GET_ERRORS, SET_EDITTING_COMPANY, DELETE_FUNDING_BY_ID, UPDATE_FUNDING_BY_ID, ADD_FUNDING,
  DELETE_EMPLOYEE_BY_ID, UPDATE_EMPLOYEE_BY_ID, ADD_EMPLOYEE,
} from "./actiontypes";

const env = process.env.NODE_ENV || 'development';
const config = require('../config.json')[env];

const btoa = require('btoa');
const basicAuth = 'Basic ' + btoa(config.api_credentials);

const instance = axios.create({
  baseURL: config.main_server,
  timeout: 8000,
  headers: {
    'content-type': 'application/json',
    'auth': basicAuth,
  },
});

export const getCompanybyName = name => dispatch => {
  instance
    .get(`/api/companies/${name}`)
    .then(res => {
      dispatch({
        type: SET_EDITTING_COMPANY,
        payload: res.data
      })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const deleteFundingById = id => dispatch => {
  instance
    .delete(`/api/companies/funding`, { params:{ id } })
    .then(res => {
      dispatch({
        type: DELETE_FUNDING_BY_ID,
        payload: res.data
      })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const deleteEmployeeById = id => dispatch => {
  instance
    .delete(`/api/companies/employee`, { params:{ id } })
    .then(res => {
      dispatch({
        type: DELETE_EMPLOYEE_BY_ID,
        payload: res.data
      })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const updateEmployeeById = (index, id, newData) => dispatch => {
  return instance
    .put(`/api/companies/employee`, newData,  { params:{ id } })
    .then(res => {
      dispatch({
        type: UPDATE_EMPLOYEE_BY_ID,
        payload: {index, newData}
      })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const addEmployee = (newData) => dispatch => {
  return instance
    .post(`/api/companies/employee`, newData)
    .then(res => {
      dispatch({
        type: ADD_EMPLOYEE,
        payload: res.data
      })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};
export const updateFundingById = (index, id, newData) => dispatch => {
  return instance
    .put(`/api/companies/funding`, newData,  { params:{ id } })
    .then(res => {
      dispatch({
        type: UPDATE_FUNDING_BY_ID,
        payload: {index, newData}
      })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const addFunding = (newData) => dispatch => {
  return instance
    .post(`/api/companies/funding`, newData)
    .then(res => {
      dispatch({
        type: ADD_FUNDING,
        payload: res.data
      })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};




// WEBPACK FOOTER //
// ./client/src/actions/CompanyAction.js